module.exports = "./assets/images/pic3.jpeg";